import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import styles from './Descripcion.module.css'

const LONGITUD_TEXTO = 300
const Descripcion = ({ descripcion }) => {
  const [expanded, setExpanded] = useState(false)
  const [textoCorto, setTextoCorto] = useState('')

  useEffect(() => {
    if (descripcion) {
      setTextoCorto(descripcion.slice(0, LONGITUD_TEXTO))
    }
  }, [descripcion])
  const esLargo = descripcion && descripcion.length > LONGITUD_TEXTO
  return (
    <div className="row">
      <div className="col">
        <p className="titulo-detalle">Descripcion</p>
        <div className="row informacion">
          <div className="col">
            <p className={styles.descripcionTexto}>
              {expanded ? descripcion : textoCorto}
            </p>
            {esLargo && (
              <button className={styles.btnVerMas} onClick={() => setExpanded(!expanded)}>
                {expanded ? 'Ver menos' : 'Ver más'}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

Descripcion.propTypes = {
  descripcion: PropTypes.string.isRequired
}

export default Descripcion
